export enum ProcessTab {
  CANDIDATE_LIST = 'CANDIDATE_LIST',
  CV_SEARCH = 'CV_SEARCH',
  PROCESS_INFORMATION = 'PROCESS_INFORMATION',
}
